import React from "react";
import styled from "styled-components";

const Loader = ({ percentage }) => {
  return (
    <StyledWrapper>
      <div className="loader_wrapper">
        <div className="dots">
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
        </div>
        <p className="loader_message the-seasons-font">
          Loading {percentage}% ...
        </p>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .loader_wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fefefe;
    z-index: 9999;
  }

  .dots {
    display: flex;
    gap: 8px;
  }

  .dot {
    width: 10px;
    height: 10px;
    background-color: #5b534c;
    border-radius: 50%;
    animation: bounce 1.5s infinite ease-in-out;
  }

  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  .dot:nth-child(4) {
    animation-delay: 0.6s;
  }

  .dot:nth-child(5) {
    animation-delay: 0.8s;
  }

  .dot:nth-child(6) {
    animation-delay: 1s;
  }

  .loader_message {
    margin-top: 16px;
    font-size: 1.2rem;
    color: #333;
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

export default Loader;
